/**
 * Enum loại số dư đầu kì theo tab
 * nvtoan2 15/09/2022
 */
export default {
  OPAccountBalance: 1, // Số dư tài khoản
  OPBankAccountBalance: 2, // Số dư TK ngân hàng
  OPCustomerBalance: 3, // Công nợ khách hàng
  OPSupplierBalance: 4, // Công nợ nhà cung cấp
  OPEmployeeBalance: 5, //  Công nợ cán bộ
  OPInventory: 6, // Tồn kho VTHH
  OPBalanceDetail: 7, //Chi tiết theo số tài khoản
  OPObjectBalance: 8, //Chi tiết theo đối tượng
};
